import { useIsomorphicLayoutEffect } from '@contra/react-hooks/useIsomorphicLayoutEffect';
import { useRef } from 'react';

const getScrollbarWidth = (): number =>
  window.innerWidth - document.documentElement.clientWidth;

export const usePreventLayoutShifting = (
  isModalOpen: boolean,
  selector?: string,
) => {
  const memoizedPadding = useRef<number>(
    typeof window === 'undefined' ? 0 : getScrollbarWidth(),
  );

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const navbar = document.querySelector(selector ?? '.modal-shift-override');

    if (!(navbar instanceof HTMLElement)) return;

    if (!isModalOpen) {
      memoizedPadding.current = getScrollbarWidth();
      navbar.style.paddingRight = '0px';
      return;
    }

    navbar.style.paddingRight = `${memoizedPadding.current}px`;
  }, [isModalOpen, selector]);
};
